import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import CountDown from '../../containers/countdown/CountDown'
import { countDownType, membershipNameType, serverDateFormat } from '../../utils/constant'
import { SETTING } from 'routes/routeConstant'
import { getCurrentStreak } from '../../redux/actions/streakAction'
import moment from 'moment'
import Loader from '../../containers/loader/loader'
import { useNavigate } from 'react-router-dom'
import WordsDiscoveryCallout from './WordsDiscoveryCallout'

interface IDateItemProps {
  currentStreak: any
  dateAdd: number
}
const DateItem: React.FC<IDateItemProps> = (props: any) => {
  const { dateAdd, currentStreak } = props
  let valueMoment = moment(),
    isActive = false
  if (dateAdd !== 0) {
    valueMoment = moment().add(dateAdd, 'days')
  }
  if (dateAdd <= 0) {
    isActive = currentStreak?.dates?.indexOf(valueMoment.format(serverDateFormat)) > -1
  }
  return (
    <div className={'story-finish-streak-item'}>
      <img src={isActive ? '/images/icons/story-finish-active.svg' : '/images/icons/icon-streak.svg'} />
      <span className={`story-finish-streak-item-value ${isActive ? 'active' : ''}`}>{valueMoment.date()}</span>
    </div>
  )
}

interface IPremiumStoryFinishedProps {
  readAgain: any
}
const PremiumStoryFinished: React.FC<IPremiumStoryFinishedProps> = (props: any) => {
  const { readAgain, currentLoading, currentStreak, membership } = props
  const { t } = useTranslation('dashboard')
  const navigate = useNavigate()
  const isTeacher = membership?.name === membershipNameType.Teacher

  useEffect(() => {
    if (!currentLoading && !currentStreak) {
      getCurrentStreak()
    }
  }, [currentStreak, currentLoading])

  const onStreakClick = () => {
    navigate(`${SETTING}#streaks`)
  }
  return (
    <div className='section-2'>
      <div className='section-story w-container'>
        <div className='w-row section-story-finished'>
          <div className='story-finished-countdown-meta'>
            <div className='section-countdown'>
              <div className='countdown-title'>{t('finished.nextLessonIn')} </div>
              <CountDown type={countDownType.Day} />
            </div>
          </div>
          <div className='w-col-12 icon-finished'>
            <img src='/images/icons/premium-finish.svg' alt='' />
          </div>
          <div className='w-col-12 story-finished-title'>
            <span>{t('finished.wellDone')}</span>
          </div>
          {(currentStreak && (
            <div className={'m-flx m-sp-around '}>
              <DateItem dateAdd={-4} currentStreak={currentStreak} />
              <DateItem dateAdd={-3} currentStreak={currentStreak} />
              <DateItem dateAdd={-2} currentStreak={currentStreak} />
              <DateItem dateAdd={-1} currentStreak={currentStreak} />
              <DateItem dateAdd={0} currentStreak={currentStreak} />
              <DateItem dateAdd={1} currentStreak={currentStreak} />
              <DateItem dateAdd={2} currentStreak={currentStreak} />
            </div>
          )) ||
            (currentLoading && <Loader showText={false} />)}
          <div className='w-col-12 story-finished-upgrade'>
            {currentStreak && (
              <p>{t('finished.streak', { count: Number(currentStreak?.counter) || 0 })}</p>
            )}
            <a className='button-4 w-inline-block m-link' onClick={readAgain}>
              {t('finished.readAgain')}
            </a>
          </div>
          <div className={'story-finish-streak-link'}>
            <p className={'m-link color-primary m-b'} onClick={onStreakClick}>
              {t('finished.trackStreaks')}
            </p>
          </div>
          {!isTeacher && <WordsDiscoveryCallout />}
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: any) => ({
  credentials: state.user.credentials,
  errors: state.UI.errors,
  membership: state.user.membership,
  story: state.story.currentStory,
  lastStepEnum: state.story.lastStepEnum,
  currentStreak: state.streak.current,
  currentLoading: state.streak.currentLoading,
})

export default connect(mapStateToProps)(PremiumStoryFinished)
